module.exports = __webpack_public_path__ + "img/sao-benedito.d0eb0f81.png";